export default __webpack_public_path__ + "static/media/ab-icon.ffc4e505.webp";